import React, { useState } from "react";
import OfferHistoryCard from "./OfferHistoryCard";
import { useQueryWithSimpleErrorHandling } from "hooks";
import { OFFERS_HISTORY_QUERY } from "../queries";
import PropTypes from "prop-types";

const OfferHistoryContainer = ({ documentId }) => {
  const [offersHistory, setOffersHistory] = useState([]);

  const { loading } = useQueryWithSimpleErrorHandling(OFFERS_HISTORY_QUERY, {
    variables: { documentId },
    onCompleted: data => {
      setOffersHistory(data?.offersHistory);
    },
    fetchPolicy: "network-only"
  });

  return <OfferHistoryCard loading={loading} offersHistory={offersHistory} />;
};

OfferHistoryContainer.propTypes = {
  documentId: PropTypes.number.isRequired
};

export default OfferHistoryContainer;
